export const companyData = {
  name: 'Eletrônica 2000',
  foundedYear: 1993,
  responsible: 'Claudia Regina da Silva',
  cnpj: '13.590.059/0001-29',
  city: 'Campo Mourão',
  state: 'PR',
  phone1: '(44) 99718-1872',
  phone2: '(44) 99737-0715',
  email: 'contato@eletronica2000.com.br',
  website: 'www.eletronica2000.com.br',
  workHours: {
    weekday: 'Segunda a Sexta: 8h às 18h',
    saturday: 'Sábado: 8h às 12h',
  },
};